import React from 'react';
import { BiCheck } from 'react-icons/bi';
import './Services.css';

const Services = ({ t }) => {
  return (
    <section id='services'>
      <h5>{t("services-title")}</h5>
      <h2>{t("services-subtitle")}</h2>

      <div className="container services__container">

         <article className="service">
          <div className="service__head">
            <h3>{t("services-card1-title")}</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card1-service1")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card1-service2")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card1-service3")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card1-service4")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card1-service5")}</p>
            </li>
          </ul>
         </article>

         <article className="service">
          <div className="service__head">
            <h3>{t("services-card2-title")}</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card2-service1")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card2-service2")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card2-service3")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card2-service4")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card2-service5")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card2-service6")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card2-service7")}</p>
            </li>
          </ul>
         </article>

         <article className="service">
          <div className="service__head">
            <h3>{t("services-card3-title")}</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card3-service1")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card3-service2")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card3-service3")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card3-service4")}</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>{t("services-card3-service5")}</p>
            </li>
          </ul>
         </article>

      </div>
    </section>
  )
}

export default Services;
